import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { AppComponent } from '../app.component';
import { TransactionConstants, EnglishTranslation, MalayTranslation } from '../app.constants';
import { AppUtilityService } from '../common/app-utility.service';


declare var $: any;

@Component({
    selector: 'app-tax-status',
    templateUrl: './tax-status.component.html',
    styleUrls: ['./tax-status.component.scss']
})
export class TaxStatusComponent implements OnInit {

    taxStatus: FormGroup;
    supplier: FormArray;
    customer: FormArray;
    currControl: FormArray;
    supplierHasCrimea: boolean = false;
    customerHasCrimea: boolean = false;
    taxStatusSGTin: boolean;
    taxStatusUSATin: boolean;
    taxStatusOtherCountries: boolean;
    isEditMode: boolean = false;
    refETDL: any;
    refNTDL: any;
    refPADL: any;
    refCCDL: any;
    check_crimea: boolean;
    langTranslation: any;
    textContent: any;


    @HostListener('document:keypress', ['$event'])
    onKeyPress(elemValue) {

        if (elemValue.target.id === 'e_invoice_tin') {
            return this.AppUtility.alphaNumeric(elemValue.key)
        } 
    }


    constructor(
        public router: Router,
        private formBuilder: FormBuilder,
        private connectRestService: ConnectRestService,
        private activatedRoute: ActivatedRoute,
        public appComp: AppComponent,
        private AppUtility: AppUtilityService) { }

    ngOnInit() {
        var langTranslation = sessionStorage.getItem("language");
        this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.TaxStatusInfoScreen : MalayTranslation.TaxStatusInfoScreen;
        
        this.taxStatus = this.formBuilder.group({
            taxInfoMalaysia: ['', Validators.required],
            taxInfoUSA: [],
            USATin: [''],
            taxInfoOthers: [],
            otherCountry: [''],
            OthersTin: [''],
            activeIncome: ['', Validators.required],
            taxIDNo: [''],
            salesServiceTax: [''],
        });
        this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
        function disableSelect(elmntId) {
            $(".select-cont#" + elmntId).append("<div class='disabled-select'></div>");
        }

        function enableSelect(elemntId) {
            $("#" + elemntId + " div.disabled-select").remove();
        }
        this.callDropdownValues().then(this.appComp.loadCustomDropdown);
        const requestId = 'R0041';
        const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
        this.getResponse(requestId, flowId);
        this.hideOnPageLoad(); 

        $(document).ready(function () {
            var usaCB = false;
            var othersCB = false;

            $("#cbOthers").click(function () {
                if ($(this).is(":checked")) {
                    $(".others").show();

                    othersCB = true;
                } else {
                    $(".others").hide();
                    othersCB = false;
                }
            })
            $("#cbUsa").click(function () {
                if ($(this).is(":checked")) {
                    $(".usa").show();
                    usaCB = true;
                } else {
                    $(".usa").hide();
                    usaCB = false;
                }
            })

            $("#obaoform").validate({
                rules: {

                    "tax_country[]": {
                        required: true,
                        minlength: 1
                    },
                },
                messages: {

                    "tax_country[]": {
                        required: "Please select where do you pay your taxes"
                    },

                },
                errorPlacement: function (error, element) {

                    if (element.attr("name") == "tax_country[]") {
                        error.appendTo($("#tax_country_error_container"))
                    }
                },
                submitHandler: function (form) {
                    // $("#btn-next").prop("disabled", true);
                }

            });
        });

    }
    onInput(event: any) {
        event.target.value = event.target.value.toUpperCase();
    }
    setMYTax() {
        if ($('#cbOthers').prop('checked') == true || $('#cbUsa').prop('checked') == true) {
            this.taxStatus.controls.taxInfoMalaysia.clearValidators()
            // console.log('triggered.setMYTax() == cleared')
        } else {
            this.taxStatus.controls.taxInfoMalaysia.setValidators([Validators.required, Validators.requiredTrue])
            // console.log('triggered.setMYTax() == set')
        }
        this.taxStatus.controls.taxInfoMalaysia.updateValueAndValidity()

    }
    taxUSAChange() {
        if ($('#cbUsa').prop('checked') == true) {
            this.taxStatus.controls.USATin.setValidators(Validators.required)
        } else {
            this.taxStatus.controls.USATin.clearValidators()
        }
        this.taxStatus.controls.USATin.updateValueAndValidity()
        this.setMYTax()
    }
    taxOtherChange() {
        if ($('#cbOthers').prop('checked') == true) {
            this.taxStatus.controls.otherCountry.setValidators(Validators.required)
            // this.taxStatus.controls.OthersTin.setValidators(Validators.required)
        } else {
            this.taxStatus.controls.otherCountry.clearValidators()
            // this.taxStatus.controls.OthersTin.clearValidators()
        }
        this.taxStatus.controls.otherCountry.updateValueAndValidity()
        // this.taxStatus.controls.OthersTin.updateValueAndValidity()
        this.setMYTax()
    }
    async callDropdownValues() {
        this.refETDL = JSON.parse(sessionStorage.RefETDL);
        this.refNTDL = JSON.parse(sessionStorage.RefNTDL);
        this.refPADL = JSON.parse(sessionStorage.RefPADL);
        this.refCCDL = JSON.parse(sessionStorage.RefCCDL);

        var tempCCDL = []
        for (var i = 0; i < this.refCCDL.length; i++) {
            if (this.refCCDL[i].Code != "MY" && this.refCCDL[i].Code != "US") {
                tempCCDL.push(this.refCCDL[i])
            }
        }
        this.refCCDL = tempCCDL
    }

    public hideOnPageLoad() {
        $(".others").hide();
        $(".usa").hide();
    }

    // method to call retrieval api
    public async getResponse(requestId, flowId) {
        const responseData = await this.connectRestService.connectRest('', requestId, '');
        if (responseData.Status === 'Success') {
            this.setFormData(responseData);
        }
    }

    // method to set formdata during pageload
    public setFormData(responseData) {
        const data = responseData.KYCQuestionnaires;
        const activeIncome = data.ActiveIncome ? 'Yes' : (data.ActiveIncome === false ? 'No' : '')
        this.taxStatus.controls.activeIncome.setValue(activeIncome);

        if (responseData.EInvoicing) {
            this.taxStatus.controls.taxIDNo.setValue(responseData.EInvoicing.TaxIDNo);
            this.taxStatus.controls.salesServiceTax.setValue(responseData.EInvoicing.SalesServiceTax);

        }

        if (responseData.TaxInfo && responseData.TaxInfo.length > 0) {
            for (let country of responseData.TaxInfo) {
                if (country.TaxCountry === TransactionConstants.TaxInfoMalaysia) {
                    this.taxStatus.controls.taxInfoMalaysia.setValue(country.IsSelected);
                } else if (country.TaxCountry === TransactionConstants.TaxInfoUSA) {
                    this.taxStatus.controls.taxInfoUSA.setValue(country.IsSelected);
                    this.taxStatus.controls.USATin.setValue(country.TINNumber);
                    if (country.IsSelected) {
                        $(".usa").show();
                        this.taxUSAChange()
                    }
                } else if (country.TaxCountry === TransactionConstants.TaxInfoOthers) {
                    this.taxStatus.controls.taxInfoOthers.setValue(country.IsSelected);
                    if (country.IsSelected) {
                        $(".others").show();
                        for (var i = 0; country.TaxCountryList.length > 0; i++) {
                            this.taxStatus.controls.otherCountry.setValue(country.TaxCountryList[i].TaxCountry);
                            this.taxStatus.controls.OthersTin.setValue(country.TaxCountryList[i].TINNumber);
                        }
                    }
                }
            }
        }

    }

    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 1) {
            formArray.removeAt(0);
        }
    }

    onSubmit() {
        if ($("#obaoform").valid()) {
            let serviceBody = {
                "KYCQuestionnaires": {
                    "ActiveIncome": this.taxStatus.value.activeIncome === 'Yes' ? true : false,
                },
                "EInvoicing": {
                    "TaxIDNo": this.taxStatus.value.taxIDNo.toUpperCase(),
                    "SalesServiceTax": this.taxStatus.value.salesServiceTax.toUpperCase()
                },
                "TaxInfo": [
                    {
                        "TaxCountry": "MY",
                        "IsSelected": this.taxStatus.value.taxInfoMalaysia,
                        "TINAvailable": this.taxStatus.value.taxInfoMalaysia,
                        "TINNumber": ""
                    },
                    {
                        "TaxCountry": "US",
                        "IsSelected": this.taxStatus.value.taxInfoUSA,
                        "TINAvailable": this.taxStatus.value.taxInfoUSA,
                        "TINNumber": this.taxStatus.value.USATin
                    },
                    {
                        "TaxCountry": "OTH",
                        "IsSelected": this.taxStatus.value.taxInfoOthers,
                        "TaxCountryList": [
                            {
                                "TaxCountry": this.taxStatus.value.otherCountry,
                                "TINAvailable": this.taxStatus.value.taxInfoOthers,
                                "TINNumber": this.taxStatus.value.OthersTin
                            },
                        ]
                    }

                ]

            };

            this.restConnect(serviceBody);
        }
    }
    async restConnect(data) {
        const RequestID = 'S0041';
        const responseData = await this.connectRestService.connectRest(data, RequestID, '')
        if (responseData.Status === 'Success') {
            if (!this.isEditMode) {
                // this.router.navigate(['/business-banking']);
                this.router.navigate(['/about-your-transaction'])
            } else {
                // console.log("success")
                // this.router.navigate(['/director-confirm']);
            }
        }
    }

    checkTinError() {
        return this.taxStatus.controls['taxIDNo'].status === "INVALID" && this.taxStatus.controls['taxIDNo'].errors.minlength ? true : false;
    }

    checkSsnError() {
        return this.taxStatus.controls['salesServiceTax'].status === "INVALID" && this.taxStatus.controls['salesServiceTax'].errors.minlength ? true : false;
    }

}